import { ReportDefinition } from '../../../services/reports.service';

// Keep report IDs aligned with backend/src/features/reports/catalog.js.
export const REPORT_CATALOG: ReportDefinition[] = [
  {
    "id": "sales-daily",
    "category": "sales",
    "title": "Daily sales",
    "description": "Paid sales and average bills, day by day.",
    "permission": "reports.sales",
    "current": false
  },
  {
    "id": "sales-hourly",
    "category": "sales",
    "title": "Hourly sales",
    "description": "Find your busiest hours of service.",
    "permission": "reports.sales",
    "current": false
  },
  {
    "id": "sales-channels",
    "category": "sales",
    "title": "Sales by channel",
    "description": "Compare POS, online and table ordering.",
    "permission": "reports.sales",
    "current": false
  },
  {
    "id": "sales-types",
    "category": "sales",
    "title": "Sales by order type",
    "description": "Compare dine-in, takeaway and delivery.",
    "permission": "reports.sales",
    "current": false
  },
  {
    "id": "sales-orders",
    "category": "sales",
    "title": "Order register",
    "description": "Find orders, check their details and export your register.",
    "permission": "reports.sales",
    "current": false
  },
  {
    "id": "menu-items",
    "category": "menu",
    "title": "Item & size sales",
    "description": "See quantities and sales for each dish and size.",
    "permission": "reports.menu",
    "current": false
  },
  {
    "id": "menu-categories",
    "category": "menu",
    "title": "Category sales",
    "description": "Compare sales across your menu categories.",
    "permission": "reports.menu",
    "current": false
  },
  {
    "id": "menu-modifiers",
    "category": "menu",
    "title": "Modifiers & add-ons",
    "description": "Track the extras guests choose with their meals.",
    "permission": "reports.menu",
    "current": false
  },
  {
    "id": "payments-methods",
    "category": "payments",
    "title": "Payment methods",
    "description": "Cash, cards, UPI and payment-link breakdowns.",
    "permission": "reports.payments",
    "current": false
  },
  {
    "id": "payments-register",
    "category": "payments",
    "title": "Payment register",
    "description": "Review payment methods and references by order.",
    "permission": "reports.payments",
    "current": false
  },
  {
    "id": "payments-refunds",
    "category": "payments",
    "title": "Completed refunds",
    "description": "Review completed refunds by refund date.",
    "permission": "reports.payments",
    "current": false
  },
  {
    "id": "payments-pending",
    "category": "payments",
    "title": "Unpaid orders",
    "description": "Identify active orders still awaiting payment.",
    "permission": "reports.payments",
    "current": false
  },
  {
    "id": "inventory-stock",
    "category": "inventory",
    "title": "Stock on hand",
    "description": "Current quantities and ingredient values.",
    "permission": "reports.inventory",
    "current": true
  },
  {
    "id": "inventory-low",
    "category": "inventory",
    "title": "Low & out-of-stock",
    "description": "Find ingredients that need replenishing.",
    "permission": "reports.inventory",
    "current": true
  },
  {
    "id": "inventory-movements",
    "category": "inventory",
    "title": "Stock movements",
    "description": "Receipts, consumption and stock adjustments.",
    "permission": "reports.inventory",
    "current": false
  },
  {
    "id": "inventory-waste",
    "category": "inventory",
    "title": "Wastage",
    "description": "Recorded food waste and its cost at the time.",
    "permission": "reports.inventory",
    "current": false
  },
  {
    "id": "inventory-variance",
    "category": "inventory",
    "title": "Stock-count variance",
    "description": "Count adjustments and their recorded value.",
    "permission": "reports.inventory",
    "current": false
  },
  {
    "id": "customers-spend",
    "category": "customers",
    "title": "Customer sales",
    "description": "Spending and visit frequency for identified guests.",
    "permission": "reports.customers",
    "current": false
  },
  {
    "id": "customers-frequency",
    "category": "customers",
    "title": "Repeat purchasing",
    "description": "How often identified guests ordered in this period.",
    "permission": "reports.customers",
    "current": false
  },
  {
    "id": "customers-areas",
    "category": "customers",
    "title": "Delivery areas",
    "description": "Order volumes and sales by delivery PIN code.",
    "permission": "reports.customers",
    "current": false
  },
  {
    "id": "customers-feedback",
    "category": "customers",
    "title": "Guest feedback",
    "description": "Submitted ratings and guest comments.",
    "permission": "reports.customers",
    "current": false
  }
];
